var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPennant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 60,
    viewBox: "0 0 42 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8852 60C39.5215 60 39.1713 59.9069 38.8345 59.7207L21 49.5479L3.19243 59.7075C2.85568 59.8936 2.50546 60 2.12829 60C1.10456 60 0 59.2021 0 57.8989V5.73138C0 2.56649 2.61322 0 5.80565 0H36.1944C39.4003 0 42 2.57979 42 5.73138V57.9122C42 58.6436 41.6498 59.1356 41.3669 59.4016C40.9628 59.7872 40.424 60 39.8852 60Z",
    fill: "#A58759"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPennant);
export default __webpack_public_path__ + "static/media/pennant.af62500fda982fc7211f6b4ec723f939.svg";
export { ForwardRef as ReactComponent };